import React from 'react';
// import { authRoles } from '../../auth/authRoles';

const reportRoutes = [
	{
		path: '/report-input',
		component: React.lazy(() => import('./ReportInput')),
	},
	{
		path: '/report-browse',
		component: React.lazy(() => import('./ReportBrowse')),
	},
];

export default reportRoutes;
